import { useEffect, useState } from 'react'
import { createPortal } from 'react-dom'
import { CircleCheck, CircleAlert, Info, TriangleAlert, X } from 'lucide-react'
import { dismiss, subscribeToasts, type ToastItem, type ToastKind } from '@/api/message'
import './ToastHost.scss'

const ICONS: Record<ToastKind, typeof Info> = {
  success: CircleCheck,
  error: CircleAlert,
  warning: TriangleAlert,
  info: Info,
}

// Fixed top-center toast stack; portal so overlays never clip it.
export default function ToastHost() {
  const [items, setItems] = useState<ToastItem[]>([])

  useEffect(() => subscribeToasts(setItems), [])

  if (!items.length) return null

  return createPortal(
    <div className="toast-stack" role="status" aria-live="polite">
      {items.map((item) => {
        const Icon = ICONS[item.kind]
        return (
          <div key={item.id} className={`toast-item is-${item.kind}`}>
            <Icon size={15} className="toast-icon shrink-0" />
            <span className="toast-text">{item.content}</span>
            <button
              type="button"
              className="toast-close"
              aria-label="close"
              onClick={() => dismiss(item.id)}
            >
              <X size={13} />
            </button>
          </div>
        )
      })}
    </div>,
    document.body,
  )
}
